module.exports = __webpack_public_path__ + "img/img1.4c641fe8.jpg";